<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ search }}<br /><br />
    {{ item }} -->

    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable text-left">
        <b-card-body class="py-0">
          <b-tabs class="gridtabs">
            <b-tab :active="true">
              <template #title>
                <div class="badgecontainer pr-5">
                  <i :class="options.icon" class="text-primary mr-1"></i>
                  <span class="text-center badgenormal badge-secondary badge-pill">
                    {{ item.code }}
                  </span>
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </div>
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="S/L" label-for="code" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.code" placeholder="Enter slac code" size="sm"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.code = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Client Name" label-for="description" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.description" placeholder="Enter client name"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.description = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Client Code" label-for="code" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.code" placeholder="Enter client code" size="sm"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.code = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Account Type" label-for="accounttype" label-cols="12">
                      <treeselect instanceId="accounttype" type="number" v-model="item.accounttype" :clearable="true"
                        :options="accounttype_options"></treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-row><b-col>
                        <b-form-group label="OnStop?" label-for="onstop" label-cols="12">
                          <b-form-radio-group id="onstop" v-model="item.onstop" :options="[
                            { text: 'Yes', value: '1' },
                            { text: 'No', value: '0' },
                          ]" buttons button-variant="outline-success" size="sm"
                            name="radio-btn-outline"></b-form-radio-group> </b-form-group></b-col>
                      <b-col>
                        <b-form-group label="Active?" label-for="active" label-cols="12">
                          <b-form-radio-group id="active" v-model="item.active" :options="[
                            { text: 'Yes', value: 'true' },
                            { text: 'No', value: 'false' },
                          ]" buttons button-variant="outline-success" size="sm"
                            name="radio-btn-outline"></b-form-radio-group> </b-form-group></b-col></b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6">
                    <b-form-group label="Addressee" label-for="address_addressee" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.address_addressee" placeholder="Enter addressee"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.address_addressee = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Attributes" label-for="attributes" label-cols="12" id="attributes">
                      <b-input-group class="treeselect_all justify-content-end pr-2px">
                        <span style="padding-top: 0.3em" class="text-primary" id="inputlist-tooltip">Input</span>
                        <b-form-checkbox id="inputlist" v-model="attributes_input" class="z-0">
                        </b-form-checkbox>
                      </b-input-group>

                      <b-input-group v-if="attributes_input">
                        <b-form-input type="text" v-model="item.attributes" placeholder="Enter attributes"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.attributes = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>

                      <b-input-group v-else>
                        <treeselect instanceId="attributes_options" type="text" v-model="attributes" :clearable="true"
                          :options="attributes_options" :multiple="true"></treeselect>
                      </b-input-group>
                    </b-form-group>
                    <b-tooltip target="attributes" triggers="hover">PO=Purchase Order Required, S=Stopped, CS=Client
                      Stats</b-tooltip>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="MD" label-for="md" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.md" placeholder="Enter MD" size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.md = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6">
                    <b-form-group label="Address Line 1" label-for="address_line1" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.address_line1" placeholder="Enter address line 1"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.address_line1 = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Financial" label-for="financial" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.financial" placeholder="Enter financial"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.financial = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Team Manager" label-for="teammanager" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.teammanager" placeholder="Enter team manager"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.teammanager = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6">
                    <b-form-group label="Address Line 2 (optional)" label-for="address_line2" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.address_line2" placeholder="Enter address line 2"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.address_line2 = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Team Sec" label-for="teamsec" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.teamsec" placeholder="Enter team sec"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.teamsec = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Currency" label-for="currency" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.currency" placeholder="Enter currency"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.currency = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6">
                    <b-form-group label="City/Town" label-for="address_city" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.address_city" placeholder="Enter city/town"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.address_city = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Pay Method" label-for="paymethod" label-cols="12">
                      <treeselect instanceId="paymethod" type="number" v-model="item.paymethod" :clearable="false"
                        :options="paymethod_options"></treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Statement Mail Type" label-for="statementtype" label-cols="12">
                      <treeselect instanceId="statementtype" type="number" v-model="item.statementtype"
                        :clearable="true" :options="statementtype_options"></treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6">
                    <b-form-group label="County (optional)" label-for="address_county" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.address_county" placeholder="Enter county"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.address_county = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Invoice Mail Type" label-for="invoicetype" label-cols="12">
                      <treeselect instanceId="invoicetype" type="number" v-model="item.invoicetype" :clearable="true"
                        :options="statementtype_options"></treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Budget" label-for="budget" label-cols="12">
                      <treeselect instanceId="budget" type="number" v-model="item.salesgroup" :clearable="false"
                        :options="budget_options"></treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6">
                    <b-form-group label="Postcode" label-for="address_postcode" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.address_postcode" placeholder="Enter postcode"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.address_postcode = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Email For Documents" label-for="emaildocuments" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.emaildocuments" placeholder="Enter email for documents"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.emaildocuments = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Carbon Type" label-for="carbon_type" label-cols="12">
                      <treeselect instanceId="carbon_type" type="number" v-model="item.carbon_type" :clearable="true"
                        :options="carbontype_options"></treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Country" label-for="address_country" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.address_country" placeholder="Enter country" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.address_country = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Country ISO" label-for="address_countryiso" label-cols="12">
                      <treeselect instanceId="address_countryiso" type="number" v-model="item.address_countryiso"
                        :clearable="true" :options="country_options"></treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Statement Address?" label-for="statementaddress" label-cols="12">
                      <b-form-radio-group id="statementaddress" v-model="item.statementaddress" :options="[
                        { text: 'Same', value: 'true' },
                        { text: 'Different', value: 'false' },
                      ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Currently Selected?" label-for="currentlyselected" label-cols="12">
                      <b-form-radio-group id="currentlyselected" v-model="item.currentlyselected" :options="[
                        { text: 'Selected', value: 'true' },
                        { text: 'Not Selected', value: 'false' },
                      ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col>

                </b-row>

                <b-row>


                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Postcode" label-for="postcode" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.postcode" placeholder="Enter postcode"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.postcode = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Tel No 1" label-for="phone1" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.phone1" placeholder="Enter phone no 1"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.phone1 = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Fax No 1" label-for="fax1" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.fax1" placeholder="Enter fax no 1"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.fax1 = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Tel No 2" label-for="phone2" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.phone2" placeholder="Enter phone no 2"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.phone2 = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Fax No 2" label-for="fax2" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.fax2" placeholder="Enter fax no 2"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.fax2 = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Company Reg No" label-for="regno" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.regno" placeholder="Enter Company Reg No"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.regno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Vat No" label-for="vatno" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.vatno" placeholder="Enter Vat No"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.vatno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>


                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Attributes"
                label-for="attributes"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.attributes"
                    placeholder="Attributes"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.attributes = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col> -->

                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Comments" label-for="comments" label-cols="12">
                      <b-form-textarea id="data" v-model="item.comments" placeholder="Comments" rows="6" max-rows="8"
                        class="smalltextarea"></b-form-textarea>
                    </b-form-group> </b-col></b-row>
                <b-row>


                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Salutation" label-for="salutation" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.salutation" placeholder="Enter salutation"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.salutation = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->







                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Credit Card" label-for="creditcard" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.creditcard" placeholder="Enter credit card"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.creditcard = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Control A/C" label-for="controlac" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.controlac" placeholder="Enter control A/C"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.controlac = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->

                </b-row>
                <b-row>

                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Send Mail?" label-for="sendmail" label-cols="12">
                      <b-form-radio-group id="sendmail" v-model="item.sendmail" :options="[
                        { text: 'Send', value: 'true' },
                        { text: 'Never', value: 'false' },
                      ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col> -->
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Address?" label-for="mailingonly" label-cols="12">
                      <b-form-radio-group id="mailingonly" v-model="item.mailingonly" :options="[
                        { text: 'General', value: 'true' },
                        { text: 'Mailing Only', value: 'false' },
                      ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col> -->

                </b-row>

                <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters>
                  <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                    Credit Control
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-row>
                      <b-col>
                        <b-form-group label="Credit Enabled?" label-for="cractive" label-cols="12">
                          <b-form-radio-group id="cractive" v-model="item.cractive" :options="[
                            { text: 'Yes', value: '1' },
                            { text: 'No', value: '0' },
                          ]" buttons button-variant="outline-success" size="sm"
                            name="radio-btn-outline"></b-form-radio-group>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group label="Notify %" label-for="crnotify" label-cols="12">
                          <b-input-group>
                            <b-form-input type="text" v-model="item.crnotify" placeholder="Notify %" size="sm"
                              :disabled="readonly"></b-form-input>
                            <b-input-group-append>
                              <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                                @click="item.crnotify = '0'">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Credit Limit" label-for="crlimit" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.crlimit" placeholder="Credit Limit" size="sm"
                          :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                            @click="item.crlimit = '0'">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Credit Checked" label-size="sm" :disabled="true">
                      <b-input-group>
                        <b-form-input :value="item.crchecked_at
                          ? this.$helpers.datetimefield(item.crchecked_at)
                          : null
                          " :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.crchecked_at = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Due" label-for="crspent" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text"
                          :value="parseFloat(item.crspent).toLocaleString(undefined, { minimumFractionDigits: 2 })"
                          placeholder="Spent" size="sm" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" :disabled="true" variant="outline-secondary" @click="item.crspent = '0'">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Overdraft" label-for="croverdraft" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.croverdraft" placeholder="Overdraft" size="sm"
                          :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                            @click="item.croverdraft = '0'">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->




                </b-row>

              </p>
            </b-tab>
            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>
          </b-tabs>
        </b-card-body>

        <b-card-footer class="nopadding mt-2">
          <b-row no-gutters>
            <b-col cols="auto" class="text-left">
              <b-button squared size="sm" variant="primary" @click="saveit()"
                v-if="user.permissions.includes('setup_clients.admin')" >
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            <b-col class="text-left ml-2 mt-1">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="8">
              <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "ClientEdit",

  watch: {
    attributes: {
      handler(newVal, oldVal) {
        console.log("watch:attributes", newVal);
        if (newVal) {
          if (newVal.join(" ") != this.item.attributes) {
            this.item.attributes = newVal.join(' ')
          }
        }

      }
    },
    "item.onstop": {
      immediate: true,
      handler(newVal, oldVal) {
        console.log("watch:onstop", newVal);
        if (newVal) {
          if (!this.attributes.includes("/S")) {
            this.attributes.push("/S")
          }
        } else {
          this.attributes = this.attributes.filter(o => o !== "/S")
        }
      }
    },
    "item.cractive": {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          this.item.crlimit = this.item.cractive == true ? '0' : 'N/A'
        }
      },
    },
  },
  data() {
    return {
      busy: false,
          readonly: false,
      attributes_input: false,
      attributes_options: [
        { id: "/AO", label: "/AO | Accounts Only" },
        { id: "/PO", label: "/PO | Requires PO" },
        { id: "/S", label: "/S | OnStop" },
        { id: "/VR", label: "/VR | VAT Reclaim Client" }
      ],
      country_options: [],
      budget_options: [],
      paymethod_options: [
        { id: "CA", label: "CA" },
        { id: "CR", label: "CR" },
        { id: "IN", label: "IN" },
        { id: "LC", label: "LC" },
      ],
      statementtype_options: null,
      // statementtype_options: [
      //   { id: "1", label: "1" },
      //   { id: "2", label: "2" },
      //   { id: "5", label: "5" },
      //   { id: "A", label: "A" },
      //   { id: "C", label: "C" },
      //   { id: "E", label: "E" },
      //   { id: "F", label: "F" },
      //   { id: "H", label: "H" },
      //   { id: "M", label: "M" },
      //   { id: "N", label: "N" },
      //   { id: "P", label: "P" },
      //   { id: "S", label: "S" },
      //   { id: "T", label: "T" },
      //   { id: "U", label: "U" },
      //   { id: "W", label: "W" },
      //   { id: "Y", label: "Y" },
      // ],
      // invoicetype_options: [],
      // invoicetype_options: [
      //   { id: "E", label: "E" },
      //   { id: "N", label: "N" },
      //   { id: "P", label: "P" },
      //   { id: "Y", label: "Y" },
      // ],
      accounttype_options: [],
      carbontype_options: [{ id: "thrust", label: "Thrust Carbon" }],
      attributes: [],
      item: {
        code: null,
        description: null,
        address_addressee: null,
        address_line1: null,
        address_line2: null,
        address_city: null,
        address_county: null,
        address_postcode: null,
        address_countryiso: null,
        address_country: "UK",
        postcode: null,
        phone1: null,
        // fax1: null,
        phone2: null,
        // fax2: null,
        onstop: '0',
        active: 'true',
        // attributes: false,
        email: null,
        comments: null,
        created_at: this.$moment().format("YYYY-MM-DD"),
        created_by: null,
        statementaddress: "false",
        md: null,
        financial: null,
        teammanager: null,
        teamsec: null,
        paymethod: "IN",
        salesgroup: "F1",
        vatno: null,
        regno: null,
        statementtype: "P",
        invoicetype: "N",
        // creditcard: null,
        // salutation: null,
        emaildocuments: null,
        accounttype: null,
        carbon_type: null,
        // controlac: null,
        // sendmail: "false",
        // mailingonly: "false",
        currentlyselected: "true",
        cractive: "1",
        crchecked_at: this.$moment().format("YYYY-MM-DD"),
      },
      options: {
        title: "Client",
        icon: "fa fa-handshake-o",
      },
    };
  },
  methods: {
    async loadDDL() {
      console.log("loadDDL");
      this.busy = true;
      try {
        const response = await this.$apollo.query({
          query: gql`
            query statementtypes {
              statementtypes {
                id
                label
              }
            }
          `,
        });
        this.statementtype_options = [];
        this.statementtype_options = response.data.statementtypes;
      } catch (error) {
        console.log(error);
      }

      // try {
      //   const response = await this.$apollo.query({
      //     query: gql`
      //       query invoicetypes {
      //         invoicetypes {
      //           id
      //           label
      //         }
      //       }
      //     `,
      //   });
      //   this.invoicetype_options = response.data.invoicetypes;
      // } catch (error) {
      // }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query clientaccounttypes {
              clientaccounttypes {
                id
                label
                name
              }
            }
          `,
        });
        this.accounttype_options = response.data.clientaccounttypes;
        console.log(this.accounttype_options);
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_countries {
              setup_countries {
                id: code
                label
              }
            }
          `,
        });
        this.country_options = response.data.setup_countries;
        console.log(this.country_options);
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_budgets {
              setup_budgets {                
                id:description 
                label:description              
              }
            }
          `,
        });
        this.budget_options = response.data.setup_budgets;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async load() {
      let variables = {
        id: this.idselected,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_clients($id: String) {
              setup_clients(id: $id) {
                id
                description            
                code
                salesgroup
                vatno
                regno
                address_addressee
                address_line1
                address_line2
                address_city
                address_county
                address_postcode
                address_country
                address_countryiso
                postcode
                phone1
                # fax1
                phone2
                # fax2
                onstop
                active
                attributes
                email
                comments
                paymethod
                currency
                statementaddress
                md
                financial
                teammanager
                teamsec
                statementtype
                invoicetype
                # creditcard
                # salutation
                emaildocuments
                accounttype
                carbon_type
                # controlac
                # sendmail
                # mailingonly
                currentlyselected
                cractive
                crlimit
                crspent
                crchecked_at
                #croverdraft
                crnotify
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.setup_clients.length > 0) {
          this.item = response.data.setup_clients[0];
          if (this.item.attributes) {
            this.attributes = this.item.attributes.trim().split(" ")
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      let variables = { rows: [this.cleanit(this.item)] };
      if (this.config.action == "copy") {
        variables.rows[0].id = null;
      }
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation setup_clients_save($rows: [setup_clients_input]) {
              setup_clients_save(rows: $rows) {
                id
                description                
                code
                salesgroup
                vatno
                regno
                address_addressee
                address_line1
                address_line2
                address_city
                address_county
                address_postcode
                address_countryiso
                address_country
                postcode
                phone1
                # fax1
                phone2
                # fax2
                onstop
                active
                attributes
                email
                comments
                paymethod
                currency
                statementaddress
                md
                financial
                teammanager
                teamsec
                statementtype
                invoicetype
                # creditcard
                # salutation
                emaildocuments
                accounttype
                carbon_type
                # controlac
                # sendmail
                # mailingonly
                currentlyselected
                cractive
                crlimit
                crspent
                crchecked_at
                #croverdraft
                crnotify
              }
            }
          `,
          variables,
        });
        if (response.data.setup_clients_save.length > 0) {
          this.item = response.data.setup_clients_save[0];
          if (this.item.attributes) {
            this.attributes = this.item.attributes.trim().split(" ")
          }
        }
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style></style>